// Standardizované chyby veřejného SDK. Hostitelská aplikace dostává vždy stejný
// tvar { code, message, modelId?, details? } — nikdy interní stack trace knihoven.
// Kódy tvoří stabilní součást veřejného kontraktu (viz §20 zadání).

export const ErrorCode = Object.freeze({
  IFC_LOAD_FAILED: "IFC_LOAD_FAILED",
  IFC_PARSE_FAILED: "IFC_PARSE_FAILED",
  MODEL_NOT_FOUND: "MODEL_NOT_FOUND",
  OBJECT_NOT_FOUND: "OBJECT_NOT_FOUND",
  INVALID_GLOBAL_ID: "INVALID_GLOBAL_ID",
  UNSUPPORTED_IFC_VERSION: "UNSUPPORTED_IFC_VERSION",
  WEBGL_ERROR: "WEBGL_ERROR",
  NETWORK_ERROR: "NETWORK_ERROR",
  INVALID_ARGUMENT: "INVALID_ARGUMENT",
  NOT_INITIALIZED: "NOT_INITIALIZED",
  DESTROYED: "DESTROYED",
});

// Veřejná chyba SDK. `toJSON` dává přesně ten tvar, který se posílá i přes iframe
// bridge, aby byl kontrakt shodný pro SDK i postMessage.
export class ViewerError extends Error {
  constructor(code, message, opts = {}) {
    super(message || code);
    this.name = "ViewerError";
    this.code = code;
    if (opts.modelId != null) this.modelId = String(opts.modelId);
    this.details = opts.details || {};
    if (opts.cause !== undefined) this.cause = opts.cause;
  }
  toJSON() {
    const o = { code: this.code, message: this.message, details: this.details || {} };
    if (this.modelId != null) o.modelId = this.modelId;
    return o;
  }
}

// Zabalí libovolnou (interní) chybu do ViewerError s daným kódem; interní message
// se uchová jen v details.internal (nezobrazuje se automaticky uživateli).
export function wrapError(code, publicMessage, cause, extra = {}) {
  const details = { ...extra };
  if (cause && cause.message) details.internal = String(cause.message);
  return new ViewerError(code, publicMessage, { cause, details, modelId: extra.modelId });
}
